// OrderItem.js
import React from "react";

// MUI components
import { Box, Typography } from "@material-ui/core";

// MUI icons
import { LocalShipping, Assignment } from "@material-ui/icons";

// Styled components / styles
import {
	OrderItem,
	OrderTypeChip,
	OrderLink,
} from "../styles";


export const OrderItemComponent = ({ time_left, port_section, order }) => {
	const dateTime =
		port_section === "eta"
			? `${order.eta_datetime}`
			: `${order.etd_datetime}`;
	const date = new Date(dateTime);

	const formattedDateTime = `${date.getHours().toString().padStart(2, "0")}:${date
		.getMinutes()
		.toString()
		.padStart(2, "0")} ${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
		.toString()
		.padStart(2, "0")}`;

	const icon = <LocalShipping style={{ fontSize: 14 }} />;

	return (
		<OrderItem key={order.id}>
			<Box display="flex" alignItems="center" gap="8px">
				<OrderTypeChip
					icon={icon}
					label={port_section}
					ordertype={port_section}
					size="small"
					style={{ marginRight: "8px" }}
				/>
				<Typography style={{ color: "#6b7280", fontSize: "12px" }}>{formattedDateTime}</Typography>
			</Box>
			<OrderLink href={`#/orders/${order.id}`} target="_blank" rel="noopener">
				<Assignment style={{ fontSize: 14 }} />#{order.id}
			</OrderLink>
		</OrderItem>
	);
};